module.exports = __webpack_public_path__ + "media/images/icons/social/github-3524c849ab38de4be923b875e3b7d29c.png";